var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Pagination as SemanticPagination, } from 'semantic-ui-react';
import hoistNonReactStatics from 'hoist-non-react-statics';
const ArrowIconItems = {
    FIRST: {
        'aria-label': 'First item',
        content: '⇤',
    },
    LAST: {
        'aria-label': 'Last item',
        content: '⇥',
    },
    NEXT: {
        'aria-label': 'Next item',
        content: '→',
    },
    PREVIOUS: {
        'aria-label': 'Previous item',
        content: '←',
    },
};
const ExtendedPagination = (_a) => {
    var { firstItem = ArrowIconItems.FIRST, lastItem = ArrowIconItems.LAST, nextItem = ArrowIconItems.NEXT, prevItem = ArrowIconItems.PREVIOUS } = _a, props = __rest(_a, ["firstItem", "lastItem", "nextItem", "prevItem"]);
    return (React.createElement(SemanticPagination, Object.assign({}, props, { firstItem: firstItem, lastItem: lastItem, nextItem: nextItem, prevItem: prevItem })));
};
export const Pagination = hoistNonReactStatics(ExtendedPagination, SemanticPagination);
Pagination.displayName = 'Pagination';
export default Pagination;
//# sourceMappingURL=Pagination.js.map